import { DomainSerializer } from "src/app/global/serializables/domain.serializer";
import { AcompanhamentoVenda } from "../domain/acompanhamento-venda.model";

export class AcompanhamentoVendaSerializer extends DomainSerializer<AcompanhamentoVenda> { }